<template>
    <question-wrapper :questionId="questionId">
        <question-header :title="title"></question-header>
        <question-text :explainer="explainer" :callToAction="callToAction" v-on:click.native="doTest"></question-text>
        <div class="result"></div>
    </question-wrapper>
</template>

<script>
  import Header from './common/Header.vue'
  import Wrapper from './common/Wrapper.vue'
  import Question from './common/Question.vue'
  import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
  /**
   * This is the _*page*_ component for the  _*Welcome*_ screen
   * This page was created first so it is a little different than the rest.
   * It doesn't have a vuex module, all the data is stored in the $data property
   * Like all pages it has a header, an explanation of the test, a button to execute a function.
   * Since there is no actual test, the button just moves the user on to the first test
   */
  export default {
    name: 'Welcome',
    data () {
      return {
        explainer: [
          _('To ensure you have a great experience in our virtual classroom, we ask you to go through these quick tests to make sure your equipment is working correctly.')
        ],
        title: _('Have You Checked Your Equipment?'),
        callToAction: {
          'text': _('Let\'s Get Started'),
          'nextPage': '#browser'
        },
        questionId: 'teststart'
      }
    },
    components: {
      'question-header': Header,
      'question-wrapper': Wrapper,
      'question-text': Question
    },

    methods: {
      /**
      * _*Listens*_ to the custom _doTest_ event fired by the Question component and executes the _showBrowserDetails()_ method callback
      * @event doTest
      * @type {Event}
      */
      doTest (e) {
        e.preventDefault()
        this.$router.push('/browser')
      }
    }
  }
</script>

<style scoped></style>
